/**
 * Created by Rodrigo Quesada on 07/01/17.
 */
import {Injectable} from '@angular/core';
import {Http, Response, ResponseContentType, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs';
import {FileLocation} from './file-location.class';
import {UserImpersonationService} from '../../../domain/model/user/user-impersonation.service';

@Injectable()
export class FileService {

    constructor(private readonly _http: Http, private readonly _impersonationService: UserImpersonationService) {
    }

    exists(location: FileLocation): Observable<boolean> {
        return this._afterRefresh(() => {
            let params = new URLSearchParams();
            params.set('existenceOnly', 'true');

            return this._http.get(location.url(), location.httpOptions(params, true)).map(res => res.json());
        });
    }

    upload(files: FileList, location: FileLocation): Observable<Response> {
        // TODO report cannot read property 'headers' of undefined (when options object is not passed or headers undefined) https://github.com/stormpath/stormpath-sdk-angular/blob/c42ecc502b7b6d902ccd46b1798add92a296f147/src/stormpath/stormpath.http.ts
        if (files.length) {
            // TODO this stuff should not be necessary? Stormpath SDK's fault???
            let formData: FormData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append('file', files[i], files[i].name);
            }

            return this._http.post(location.url(), formData, location.httpOptions());
        }
        else {
            return Observable.empty();
        }
    }

    download(location: FileLocation, extraParams?: URLSearchParams): Observable<boolean> {
        return this._http.get(location.url(), location.httpOptions(extraParams).merge({responseType: ResponseContentType.Blob}))
            .do(res => {
                //get filename
                const contentDispositionHeader = res.headers.get('Content-Disposition');
                const matchResult: RegExpMatchArray | null = contentDispositionHeader && contentDispositionHeader.match(/filename="(.+)"/) || null;
                const filename: string = matchResult && matchResult[1] || 'file';

                const blob = res.blob();
                const windowUrl = window.URL || (window as any).webkitURL;
                const url = windowUrl.createObjectURL(blob);

                if (window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(blob, filename);
                } else {
                    const anchor = $('a#download-link');
                    anchor.prop('href', url);
                    anchor.prop('download', filename);
                    anchor.get(0).click();
                }

                windowUrl.revokeObjectURL(url);
            })
            .map(_ => true);
    }

    remove(location: FileLocation, extraParams?: URLSearchParams): Observable<Response> {
        return this._http.delete(location.url(), location.httpOptions(extraParams));
    }

    private _afterRefresh<R>(body: () => Observable<R>): Observable<R> {
        return this._impersonationService.dataRefreshed$.first().flatMap(body);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/files/service/file.service.ts